'use client'

import React from 'react'
import Image from 'next/image'
import { CHALLAN_WIDGET_LANDING } from '@components/Product/ProductWidget/constants'
import { defaultVehicleImage } from '@components/MainWidget/ChallanWidgetModals/constants'
import { ARROW_RIGHT_URL, previousChecks } from './constants'
import styles from './ChallanWidgetLanding.module.scss'

const ReturningUserInfoBlock = ({ userInfo, handleReturningSearch, widgetType = CHALLAN_WIDGET_LANDING }) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { db_make_name = '', db_model_name = '', model_name = '' } = userInfo?.vehicleInfo || {}
  const vehicleBrandName = `${db_make_name} ${db_model_name}`.trim() || model_name

  return (
    <div className={styles.returningUserBlockContainer}>
      <p className={styles.heading}>{previousChecks[widgetType]}</p>
      <div className={styles.infoContainer} onClick={handleReturningSearch}>
        <div className={styles.firstItem}>
          <span className={styles.brandLogo}>
            <Image
              width={20}
              height={20}
              src={userInfo?.logo_url || defaultVehicleImage?.Default}
              alt="Brand logo return user"
            />
          </span>
          <div className={styles.makeRegNo}>
            <p>{vehicleBrandName}</p>&nbsp;
            <p>{`• ${userInfo?.vehicleInfo?.registration_number || ''}`}</p>
          </div>
        </div>
        <div className={styles.secondItem}>
          <Image width={20} height={20} src={ARROW_RIGHT_URL} alt="right arrow" />
        </div>
      </div>

      <div className={styles.orBox}>
        <p>OR</p>
      </div>
    </div>
  )
}

export default ReturningUserInfoBlock
